"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigValueResponse = exports.createGetUserConfigResponse = void 0;

var _utils = require("../../../utils");

var _lodash = require("lodash");

var createGetUserConfigResponse = function createGetUserConfigResponse(component) {
  return function (raw) {
    return (0, _utils.parseModel)(raw, {
      result: {
        path: 'GetFilteredRecordListResult[0]',
        model: _utils.genericAsResultHeader
      },
      response: function response(raw) {
        var table = (0, _lodash.get)(raw, 'GenericDataSet[0].DataRow', []);
        return table.reduce(function (accumulator, row) {
          var target;

          if (component) {
            target = accumulator;
          } else {
            var _component = row.Component[0];

            if (!accumulator[_component]) {
              accumulator[_component] = {};
            }

            target = accumulator[_component];
          } // Note that there's no constraint against saving the same key with different values, so converting this to a
          // flat table may overwrite existing keys...


          target[row.Name] = {
            value: typeify(row.Value[0]),
            id: Number(row.Id[0])
          };
          return accumulator;
        }, {});
      }
    });
  };
};

exports.createGetUserConfigResponse = createGetUserConfigResponse;

var getConfigValueResponse = function getConfigValueResponse(raw) {
  return (0, _utils.parseModel)(raw, {
    result: {
      path: 'GetFilteredRecordListResult[0]',
      model: _utils.genericAsResultHeader
    },
    response: {
      path: 'GenericDataSet[0].DataRow[0].Value[0]',
      type: typeify
    }
  });
};
/**
 * Attempts to infer a value's type; "40" gets coerced to 40, "true" gets coerced to true, etc.
 * @param val
 * @returns {*}
 */


exports.getConfigValueResponse = getConfigValueResponse;

function typeify(val) {
  if (isNumber(val)) {
    return Number(val);
  }

  if (isBoolean(val)) {
    return val.toLowerCase() === 'true';
  }

  return val;
}

function isNumber(val) {
  return !Number.isNaN(Number(val));
}

function isBoolean(val) {
  return ['true', 'false'].includes(val.toLowerCase());
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/user/response-parsers/get-user-config.js
// module id = 241
// module chunks = 0